import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialSeachValue =
  new URLSearchParams(window.location.search).get('search') || '';

const initialState = {
  brand: '',
  type: '',
  search: initialSeachValue,
  category: '',
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{ key: keyof typeof initialState; value: string }>,
    ) => {
      const { key, value } = action.payload;

      state[key] = value;
    },
  },
});

export const searchReducer = searchSlice.reducer;
export const searchActions = searchSlice.actions;
